(function () {
    function isOnMarketingPage() {
        return window.location.pathname.indexOf('/marketing/') === 0;
    }

    function isOnBlastQueue() {
        return window.location.pathname === '/marketing/blasts/';
    }

    function isOnCampaignDetail() {
        return /^\/marketing\/campaigns\/\d+\//.test(window.location.pathname);
    }

    var rowRefreshes = {};

    function refreshRow(elementId, url) {
        var row = document.getElementById(elementId);
        if (!row || rowRefreshes[elementId]) return;
        rowRefreshes[elementId] = true;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.setRequestHeader('HX-Request', 'true');
        xhr.setRequestHeader('HX-Current-URL', window.location.href);
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText.trim()) {
                var parent = row.parentNode;
                if (!parent) return;
                row.outerHTML = xhr.responseText;
                if (window.htmx) htmx.process(parent);
            }
        };
        xhr.onloadend = function () {
            delete rowRefreshes[elementId];
        };
        xhr.send();
    }

    // send_blast does not broadcast per batch. Refresh only the sending rows already present
    // on the current filtered/paginated queue, so the operator sees progress without
    // replacing the list wrapper or changing its URL/state.
    function refreshSendingBlastRows() {
        if (!isOnBlastQueue() || document.hidden) return;
        var rows = document.querySelectorAll('tr[data-send-refresh][id^="blast-"]');
        for (var i = 0; i < rows.length; i++) {
            var blastId = rows[i].id.slice('blast-'.length);
            refreshRow('blast-' + blastId, '/marketing/blasts/' + blastId + '/row/');
        }
    }

    function refreshCampaignAudienceStatus(campaignId) {
        var statusPanel = document.getElementById('campaign-audience-refresh-status');
        if (!statusPanel || !window.htmx) return;
        if (campaignId !== undefined &&
                statusPanel.getAttribute('data-campaign-id') !== String(campaignId)) {
            return;
        }
        htmx.trigger(statusPanel, 'campaignAudienceRefreshUpdated');
    }

    // Nudge the blast projection card to re-fetch durable projection state. The socket
    // group is client-wide and a blast sheet can sit over another blast's page, so the
    // card is matched on its own data-blast-id, not on the page URL. Carries no state of
    // its own — marketing:blast-projection-status stays the source of truth.
    function refreshBlastProjectionCard(blastId) {
        if (!window.htmx) return;
        var cards = document.querySelectorAll('[id^="blast-projection-card-"][data-blast-id]');
        for (var i = 0; i < cards.length; i++) {
            var card = cards[i];
            if (blastId !== undefined && card.getAttribute('data-blast-id') !== String(blastId)) continue;
            htmx.trigger(card, 'blastProjectionUpdated');
        }
    }

    // Re-fetch the blast rows that are still showing a pending projection.
    //
    // Rows deliberately carry NO backstop poll of their own, unlike the projection card:
    // a queue page holds up to PAGE_SIZE (25) rows, and 25 polling rows is a different cost
    // from one polling card. What the rows get instead is this reconnect re-fetch, which
    // covers the same window the card's poll exists for — /ws/* is 502 for 10-20s while
    // Daphne and celery restart together, and a queued -> ready broadcast sent in there is
    // simply lost.
    //
    // Bounded to pending rows on purpose. A missed broadcast can only strand a row that is
    // still showing Queued / Calculating — a terminal state is what the broadcast would have
    // delivered — so the row templates emit data-projection-pending exactly while that badge
    // is on screen (and never when targeting is blocked, where the cell shows an em dash and
    // no calculation will ever run). A queue with nothing pending issues zero requests.
    function refreshPendingBlastRows() {
        var prefix, query;
        if (isOnBlastQueue()) {
            prefix = 'blast-';
            query = '';
        } else if (isOnCampaignDetail()) {
            prefix = 'campaign-blast-';
            query = '?layout=campaign';
        } else {
            return;
        }
        var rows = document.querySelectorAll('tr[data-projection-pending][id^="' + prefix + '"]');
        for (var i = 0; i < rows.length; i++) {
            var blastId = rows[i].id.slice(prefix.length);
            refreshRow(prefix + blastId, '/marketing/blasts/' + blastId + '/row/' + query);
        }
    }

    var socket = null;
    var reconnectTimer = null;
    var reconnectAttempts = 0;

    function connect() {
        if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }

        var protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
        socket = new WebSocket(protocol + '//' + location.host + '/ws/marketing/');

        socket.onopen = function () {
            reconnectAttempts = 0;
            // No refreshCampaignAudienceStatus() here on purpose. The page-load HTML already
            // reflects durable state, and for a succeeded run that state is deliberately blank
            // (_audience_refresh_status_context show_succeeded=False) so the one-time success
            // banner isn't resurrected on every reconnect. A still-live run is covered without
            // it: is_live puts "every 5s" on the panel's own hx-trigger, so a reconnect
            // self-heals by polling. Real completions still reach the panel via onmessage's
            // campaign_audience_refresh_updated branch below.
            //
            // Covers the deploy window: /ws/* is 502 while Daphne and celery restart, so a
            // projection can have settled while this socket was down. Every surface that
            // shows projection state self-heals here — the card unconditionally (a page
            // carries one, two if a sheet sits over a detail page), the rows only where the
            // projection is still pending.
            refreshBlastProjectionCard();
            refreshPendingBlastRows();
        };

        socket.onmessage = function (e) {
            var data = JSON.parse(e.data);

            if (data.type === 'blast_updated') {
                // blast.updated is also the projection nudge — every projection transition
                // (queued / calculating / ready / failed) broadcasts through it. The blast
                // detail page and sheet match neither row path below, so the card is
                // matched on its own data-blast-id instead of on the page URL.
                refreshBlastProjectionCard(data.blast_id);
                if (isOnBlastQueue()) {
                    refreshRow('blast-' + data.blast_id, '/marketing/blasts/' + data.blast_id + '/row/');
                }
                if (isOnCampaignDetail()) {
                    refreshRow('campaign-blast-' + data.blast_id, '/marketing/blasts/' + data.blast_id + '/row/?layout=campaign');
                }

            } else if (data.type === 'template_preview_updated') {
                // A template preview proof changed state — swap the pre-rendered
                // card back in (clears the spinner / shows thumbnails or the error
                // strip) if THIS template's card is on screen, and show the toast.
                // The group is client-wide, so guard on the card's template id.
                var card = document.getElementById('mail-template-preview-card');
                var matches = card &&
                    card.getAttribute('data-template-id') === String(data.template_id);
                if (matches && data.card_html) {
                    var cardParent = card.parentNode;
                    if (cardParent) {
                        card.outerHTML = data.card_html;
                        if (window.htmx) htmx.process(cardParent);
                    }
                }
                if (matches && data.toast && data.toast.message && window.SeeMe && SeeMe.toast) {
                    (SeeMe.toast[data.toast.type] || SeeMe.toast.info)(data.toast.message);
                }
            } else if (data.type === 'campaign_audience_refresh_updated') {
                // The client-wide socket event is only a fast hint. Campaign scoping
                // stays local and the status endpoint remains the source of truth.
                refreshCampaignAudienceStatus(data.campaign_id);
            }
        };

        socket.onclose = function (e) {
            socket = null;
            if (e.code === 4401) {
                window.location.href = '/login/?next=' + encodeURIComponent(window.location.pathname);
                return;
            }
            if (!isOnMarketingPage()) return;
            if (reconnectAttempts < 10) {
                var delay = Math.min(2000 * Math.pow(1.5, reconnectAttempts), 30000);
                reconnectAttempts++;
                reconnectTimer = setTimeout(connect, delay);
            }
        };
    }

    if (isOnMarketingPage()) connect();
    window.setInterval(refreshSendingBlastRows, 15000);

    function checkConnection() {
        if (isOnMarketingPage() && !socket) {
            reconnectAttempts = 0;
            connect();
        } else if (!isOnMarketingPage() && socket) {
            socket.close();
            socket = null;
            if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
        }
    }
    document.body.addEventListener('htmx:pushedIntoHistory', checkConnection);
    window.addEventListener('popstate', checkConnection);
})();
